// pages/AllTransactions.jsx
import { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import CreateTransactionModal from "../components/CreateTransactionModal";
import EditTransactionModal from "../components/EditTransactionModal";
import { exportAllTransactionsFormattedToCSV, exportAllTransactionsFormattedToXLSX } from "../utils/exportAllTransactions";
import api from '../config/api';


import "../styles/transactions.css";

export default function AllTransactions() {
  const itemsPerPage = 10;
  const [transactions, setTransactions] = useState([]);
  const [accountCodes, setAccountCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedCode, setSelectedCode] = useState("");
  const [transactionType, setTransactionType] = useState("");
  const [searchInvoice, setSearchInvoice] = useState("");
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const filteredTransactions = (transactions || []).filter((tx) => {
    const matchCode = !selectedCode || tx.account_code_id === Number(selectedCode);
    const matchType = !transactionType || tx.transaction_type === transactionType;
    const searchText = searchInvoice.toLowerCase();
    const matchSearch =
      !searchInvoice ||
      (tx.reference_number?.toLowerCase().includes(searchText)) ||
      (tx.supplier_name?.toLowerCase().includes(searchText)) ||
      (tx.description?.toLowerCase().includes(searchText));
    return matchCode && matchType && matchSearch;

  });  
  const startIndex = (currentPage - 1) * itemsPerPage + 1;
  const endIndex = Math.min(currentPage * itemsPerPage, filteredTransactions.length);

  const totalPages = Math.ceil(filteredTransactions.length / itemsPerPage);

  const paginatedTransactions = filteredTransactions.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const [isExporting, setIsExporting] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);



  const fetchTransactions = async () => {
    try {
      const query = new URLSearchParams();
      if (startDate) query.append("start", startDate);
      if (endDate) query.append("end", endDate);
      const url = api(`/transactions/by-date?${query.toString()}`);
      const token = localStorage.getItem("token");

      const response = await fetch(url, {
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      });

      const data = await response.json();
      const sorted = Array.isArray(data)
        ? [...data].filter(tx => !!tx.transaction_date).sort((a, b) => new Date(b.transaction_date) - new Date(a.transaction_date))
        : [];
      setTransactions(sorted);
    } catch (err) {
      console.error("Error fetching transactions:", err);
      setTransactions([]);
    } finally {
      setLoading(false);
    }
  };
  
  const fetchTransactionsWithCode = async () => {
    try {

      const query = new URLSearchParams();
      if (startDate) query.append("start", startDate);
      if (endDate) query.append("end", endDate);

      const url = api(`/transactions/by-date?${query.toString()}`);
      const token = localStorage.getItem("token");
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      console.log("🚀 response data:", data); // <-- Tambahkan ini
      const sorted = Array.isArray(data)
        ? data
            .filter(tx => !!tx.transaction_date && !isNaN(new Date(tx.transaction_date))) // filter null & invalid
            .sort((a, b) => new Date(b.transaction_date) - new Date(a.transaction_date))
        : [];
      setTransactions(sorted);

    } catch (err) {
      console.error("Error fetching transactions:", err);
    } finally {
      setLoading(false); // <-- Pastikan ini tetap dipanggil
    }
  };

  const handleEdit = (tx) => {
    setSelectedTransaction(tx);
    setShowEditModal(true);
  };


  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to permanently delete this transaction?");
    if (!confirmDelete) return;
  
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(api(`/transactions/${id}`), {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (!response.ok) {
        throw new Error("Failed to delete transaction.");
      }
  
      alert("Transaction deleted successfully.");
      fetchTransactions(); // Refresh list
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete transaction.");
    }
  };
  
  
  const handleCorrect = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete (correct) this transaction?");
    if (!confirmDelete) return;
  
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(api(`/transactions/${id}/correct`), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (!response.ok) {
        throw new Error("Failed to delete (correct) transaction.");
      }
  
      alert("Transaction marked as corrected.");
      // Refresh list
      fetchTransactions();
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete transaction.");
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedCode, transactionType, searchInvoice]);
    

  // Fetch all transactions from backend
  useEffect(() => {
    fetchTransactions();
  }, []);

  // Fetch account codes for filter dropdown
  useEffect(() => {
    const fetchAccountCodes = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(api("/account_codes/"), {
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        });

        const data = await response.json();
        setAccountCodes(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Error fetching account codes:", err);
        setAccountCodes([]);
      }
    };
    fetchAccountCodes();
  }, []);

  useEffect(() => {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(el => new window.bootstrap.Tooltip(el));
  }, [transactions]);
  

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Sidebar />
        <div className="layout-page">
          <Navbar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <h2 className="mb-4">View All Transactions</h2>
              <div className="card mb-4">
                <div className="card-header">
                  <h4>Filter and Search Transactions</h4>
                </div>
                <div className="card-body table-responsive">
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <label htmlFor="start-date" className="form-label">
                        Start Date:
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="start-date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="end-date" className="form-label">
                        End Date:
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="end-date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-4 d-flex align-items-end">
                      <button className="btn btn-primary w-100" onClick={fetchTransactions}>
                        Apply Filter
                      </button>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <label htmlFor="filter-kode" className="form-label">
                        Filter Account Code:
                      </label>
                      <select
                        className="form-select"
                        id="filter-kode"
                        value={selectedCode}
                        onChange={(e) => {
                          setSelectedCode(e.target.value);
                          fetchTransactionsWithCode();
                        }}
                      >
                        <option value="">All</option>
                        {accountCodes.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.code} - {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="filter-type" className="form-label">
                        Filter Transaction Type:
                      </label>
                      <select
                        className="form-select"
                        id="filter-type"
                        value={transactionType}
                        onChange={(e) => setTransactionType(e.target.value)}
                      >
                        <option value="">All</option>
                        <option value="debit">Debit</option>
                        <option value="credit">Credit</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="search-invoice" className="form-label">
                        Search Invoice Number:
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="search-invoice"
                        placeholder="Enter Invoice Number"
                        value={searchInvoice}
                        onChange={(e) => setSearchInvoice(e.target.value)}
                      />
                    </div>
                  </div>
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Description</th>
                        <th>Account Code</th>
                        <th>Transaction Type</th>
                        <th>Amount</th>
                        <th>PO/PV Number</th>
                        <th>Proof</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedTransactions.map((tx) => (
                        <tr key={tx.id}>
                          <td>{new Date(tx.transaction_date).toLocaleDateString()}</td>
                          <td className="cell-description">{tx.description}</td>
                          <td>{tx.account_code}</td>
                          <td>{tx.transaction_type}</td>
                          <td className="cell-amount">Rp. {tx.amount.toLocaleString("id-ID")}</td>
                          <td className="cell-invoice">{tx.reference_number || "-"}</td>
                          <td>
                            {tx.payment_proof_url ? (
                              <a href={tx.payment_proof_url} target="_blank" rel="noreferrer">
                                View
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>
                            <div className="d-flex gap-2">
                              <button
                                className="btn btn-sm btn-icon text-primary"
                                data-bs-toggle="tooltip"
                                title="Edit Transaction"
                                onClick={() => handleEdit(tx)}
                              >
                                <i className="bx bx-edit"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-icon text-danger"
                                data-bs-toggle="tooltip"
                                title="Delete Transaction"
                                onClick={() => handleDelete(tx.id)}
                              >
                                <i className="bx bx-trash"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <div className="d-flex justify-content-between align-items-center mt-3 px-2">
                    <small>
                      Showing {filteredTransactions.length === 0 ? 0 : startIndex} to {endIndex} of {filteredTransactions.length} transactions
                    </small>
                    <small>Page {currentPage} of {totalPages}</small>
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((prev) => prev - 1)}
                      >
                        Previous
                      </button>
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage((prev) => prev + 1)}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end mt-3 px-2 gap-2">
                    <button
                      className="btn btn-primary"
                      onClick={async () => {
                        setIsExporting(true);
                        await new Promise(resolve => setTimeout(resolve, 500));
                        exportAllTransactionsFormattedToXLSX(filteredTransactions, accountCodes);
                        setIsExporting(false);
                        setShowToast(true);
                      }}
                    >
                      {isExporting ? (
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      ) : (
                        <i className="bx bx-table me-2"></i>
                      )}
                      Export to XLSX
                    </button>

                  </div>
                  <button className="fab" onClick={() => setShowCreateModal(true)}>
                    <span className="icon">+</span>
                    <span className="label">Create Transaction</span>
                  </button>
                  {showToast && (
                    <div className="toast align-items-center text-bg-success border-0 position-fixed bottom-0 end-0 m-4 show" role="alert" aria-live="assertive" aria-atomic="true" style={{ zIndex: 9999 }}>
                      <div className="d-flex">
                        <div className="toast-body">
                          Export successful!
                        </div>
                        <button type="button" className="btn-close btn-close-white me-2 m-auto" aria-label="Close" onClick={() => setShowToast(false)}></button>
                      </div>
                    </div>
                  )}
                  <EditTransactionModal
                    show={showEditModal}
                    transaction={selectedTransaction}
                    onClose={() => setShowEditModal(false)}
                    onSuccess={() => {
                      fetchTransactions();
                      setShowEditModal(false);
                    }}
                  />
                  <CreateTransactionModal
                    show={showCreateModal}
                    onClose={() => setShowCreateModal(false)}
                    onSuccess={() => {
                      fetchTransactions();
                      setShowSuccessToast(true);
                      setTimeout(() => setShowSuccessToast(false), 3000);
                    }}
                  />
                  {showSuccessToast && (
                    <div className="toast-container position-fixed top-0 start-50 translate-middle-x p-3" style={{ zIndex: 9999 }}>
                      <div className="toast align-items-center text-bg-success show" role="alert" aria-live="assertive" aria-atomic="true">
                        <div className="d-flex">
                          <div className="toast-body">
                            Transaction created successfully!
                          </div>
                          <button type="button" className="btn-close btn-close-white me-2 m-auto" onClick={() => setShowSuccessToast(false)}></button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
